import { LocalDataKeys, TDesignSystem } from '@libs/types';
import { getLocalDataSnapshot, saveLocalData } from './utils/localDataStore';

/**
 * Persists `configuration.designSystem` from a scenario response. A response without it keeps the stored value:
 * the backend sends it only with `requestInteraction`, and app-level screens need it before the first response
 * after a reload.
 */
export const saveDesignSystem = (designSystem: TDesignSystem | undefined): void => {
    if (designSystem) {
        saveLocalData(LocalDataKeys.designSystem, designSystem);
    }
};

/** Last stored design generation, or `undefined` when the backend never sent one. */
export const getDesignGeneration = (): number | undefined => getLocalDataSnapshot<TDesignSystem>(LocalDataKeys.designSystem)?.generation;
